import React from "react";
import SVG from "react-inlinesvg";
import scrollToTopIcon from "../../../../../src/assets/img/scrollToTop.svg"

export function ScrollTop() {
  return (
      <div id="kt_scrolltop" className="scrolltop">
        <span className="svg-icon">
          <SVG src={scrollToTopIcon}></SVG>
        </span>{" "}
      </div>
  );
}
